/* eslint-disable max-lines-per-function */
import React, { useState, useEffect, useRef } from "react";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import { VueTransition } from "common/vue/VueTransition";
import { cn } from "tailwind-variants";
import "./ImageCompareLoadingContent.scss";

export default function ImageCompareLoadingContent({ enhancementTier, ...restProps }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const intervalIdRef = useRef(null);

  function contents() {
    if (enhancementTier === "full_enhancements") {
      return {
        caption: "Hang tight — we're making your design PrintPerfect",
        highlights: [
          "Enhancing resolution",
          "Boosting vibrancy",
          "Refining edges",
          "Cropping unwanted areas",
          "Removing background perfectly"
        ]
      };
    }
    return {
      caption: "Processing...",
      highlights: []
    };
  }

  // Watch enhancementTier - reset currentIndex when it changes
  useEffect(() => {
    setCurrentIndex(0);
  }, [enhancementTier]);

  // Set up and clean up interval
  useEffect(() => {
    intervalIdRef.current = setInterval(() => {
      setCurrentIndex(prevIndex => {
        const contentsData = contents();
        return (prevIndex + 1) % contentsData.highlights.length;
      });
    }, 3000);

    return () => {
      if (intervalIdRef.current) {
        clearInterval(intervalIdRef.current);
      }
    };
  }, []);

  const contentsData = contents();
  const { className: restClassName, ...otherRestProps } = restProps;
  const rootClasses = cn(
    "z-2 scope-7e963798 absolute left-1/2 top-1/2 w-[300px] -translate-x-1/2 -translate-y-1/2 p-2",
    restClassName
  );

  return (
    <div {...otherRestProps} className={rootClasses}>
      <div className="scope-7e963798 flex flex-row items-center justify-center gap-4 rounded-lg bg-white p-4 shadow-lg lg:flex-col">
        <span className="scope-7e963798 flex h-7 w-7 items-center justify-center lg:h-11 lg:w-11">
          <UseSvg
            className="scope-7e963798 size-7 text-pink-500 lg:size-11"
            icon="stars-corners"
            data-testid="size-7"
          />
        </span>
        <div className="scope-7e963798 flex flex-col items-center gap-1 text-sm lg:gap-4 lg:text-base">
          <div className="scope-7e963798 text-center">
            <div className="scope-7e963798 font-bold text-gray-700">{contentsData.caption}</div>
          </div>
          {contentsData.highlights.length > 0 ? (
            <div className="scope-7e963798 flex flex-col items-center gap-1">
              <div className="scope-7e963798 text-center text-gray-600">
                <VueTransition
                  className="scope-7e963798"
                  name="fade"
                  mode="out-in"
                  data-testid="transition"
                >
                  <span className="scope-7e963798" key={currentIndex}>
                    {contentsData.highlights[currentIndex]}
                  </span>
                </VueTransition>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
